import { Box } from '@/components/Box/Box';
import { DetailsRow } from '@/components/DetailsWidget/DetailsRow/DetailsRow';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { getPaymentDetailsData } from '../helpers/helpers';
import { BankName } from '@/bundle/shared/components/PaymentDetailsData/ui/BankName';

type GeneralPaymentDetailsType = {
  paymentDetails: PaymentDetailsGeneralType;
};

export const GeneralPaymentDetails = ({ paymentDetails }: GeneralPaymentDetailsType) => {
  if (!paymentDetails) return;

  const {
    blockchainId,
    formattedBlockchainId,
    recipientName,
    recipientAddress,
    accountName,
    bankName,
    bankAccountNumber,
    bankAddress,
    bankPhoneNumber,
    bankCodeLabel,
    bankCodeValue,
    isDataFromBlockchain,
  } = getPaymentDetailsData(paymentDetails);

  return (
    <Box>
      <DetailsRow name='Blockchain ID' title={blockchainId}>
        {formattedBlockchainId}
      </DetailsRow>
      <DetailsRow name='Recipient'>{recipientName}</DetailsRow>
      <DetailsRow name='Recipient Address' title={recipientAddress}>
        {recipientAddress}
      </DetailsRow>
      {accountName && <DetailsRow name='Account Name'>{accountName}</DetailsRow>}
      <DetailsRow name={bankCodeLabel} hasHighlight={isDataFromBlockchain}>
        {bankCodeValue}
      </DetailsRow>
      <DetailsRow name='Bank Name'>
        <BankName name={bankName} isVerified={paymentDetails?.internal_payment_details_data?.is_bank_name_verified} />
      </DetailsRow>
      <DetailsRow name='Account Number' hasHighlight={isDataFromBlockchain}>
        {bankAccountNumber}
      </DetailsRow>
      <DetailsRow name='Bank Address'>{bankAddress}</DetailsRow>
      <DetailsRow name='Bank Phone Number'>{bankPhoneNumber}</DetailsRow>
    </Box>
  );
};
